<template>
    <div class="sider-list-1" @click="init" ref="sider">
        <div class="sider-title" v-text="title"></div>
        <ul class="list-1">
            <li>
                <!-- 全部网吧 -->
                <router-link
                    :to="
                        $PAGE_API.home.children.barManager.children.index
                            .children.allBar.path
                    "
                >
                    <span
                        v-text="
                            $PAGE_API.home.children.barManager.children.index
                                .children.allBar.title
                        "
                    ></span>
                    <div>
                        <span v-text="allBarNumInfo.online"></span>
                        <span>/</span>
                        <span v-text="allBarNumInfo.total"></span>
                    </div>
                </router-link>
            </li>
            <li v-show="hasRemote">
                <!-- 最近远程 -->
                <router-link
                    :to="
                        $PAGE_API.home.children.barManager.children.index
                            .children.recentRemote.path
                    "
                >
                    <span
                        v-text="
                            $PAGE_API.home.children.barManager.children.index
                                .children.recentRemote.title
                        "
                    ></span>
                    <div>
                        <span v-text="recentRemoteNum"></span>
                    </div>
                </router-link>
            </li>
            <li>
                <!-- 服务器离线的网吧 -->
                <router-link
                    :to="
                        $PAGE_API.home.children.barManager.children.index
                            .children.serverOfflineBar.path
                    "
                >
                    <span
                        v-text="
                            $PAGE_API.home.children.barManager.children.index
                                .children.serverOfflineBar.title
                        "
                        >服务器离线的网吧</span
                    >
                    <div>
                        <span v-text="serverOfflineBarNum"></span>
                    </div>
                </router-link>
            </li>
            <li v-show="passportType == 0 || passportType == 2">
                <!-- 服务器标签管理 -->
                <router-link
                    :to="
                        $PAGE_API.home.children.barManager.children.index
                            .children.serverLabelManage.path
                    "
                >
                    <span
                        v-text="
                            $PAGE_API.home.children.barManager.children.index
                                .children.serverLabelManage.title
                        "
                        >服务器标签管理</span
                    >
                </router-link>
            </li>
        </ul>
        <div v-show="hasRemote">
            <div class="line"></div>
            <ul class="list-2">
                <li>
                    <!-- 远程协助记录 -->
                    <router-link
                        :to="
                            $PAGE_API.home.children.barManager.children.index
                                .children.remoteRecord.path
                        "
                    >
                        <span
                            v-text="
                                $PAGE_API.home.children.barManager.children
                                    .index.children.remoteRecord.title
                            "
                            >远程协助记录</span
                        >
                        <div>
                            <span v-text="assistRemoteNum"></span>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="line"></div>
        <ul class="list4">
            <li
                v-for="(item, index) in groupList"
                :key="index"
                @click.prevent.stop="getGroupBarList(item.groupId)"
            >
                <div>
                    <div class="title">
                        <span
                            v-text="item.groupName"
                            :title="item.groupName"
                        ></span>
                        <div>
                            <span v-text="item.activeBarCnt"></span>
                            <span>/</span>
                            <span v-text="item.totalBarCnt"></span>
                        </div>
                    </div>
                    <ul>
                        <li
                            v-for="(it, ind) in groupBarList"
                            :key="ind"
                            v-show="item.groupName == it.groupName"
                            @click.prevent.stop="toPage(it.barId, ind)"
                        >
                            <div
                                :style="{
                                    background:
                                        ind == current && it.barId == groupBarId
                                            ? '#fff'
                                            : '#eaedf1'
                                }"
                            >
                                <span
                                    class="icon"
                                    style="position: relative;top: 5px;"
                                >
                                    <img
                                        src="@/assets/img/icon/gray.png"
                                        alt=""
                                        v-show="
                                            (it.bsOnlineCnt == 0 &&
                                                it.bsOnlineCnt <
                                                    it.totalBsCnt) ||
                                                (it.bsOnlineCnt ==
                                                    it.totalBsCnt &&
                                                    it.bsOnlineCnt == 0 &&
                                                    it.totalBsCnt == 0)
                                        "
                                    />
                                    <img
                                        src="@/assets/img/icon/yellow.png"
                                        alt=""
                                        v-show="
                                            it.bsOnlineCnt < it.totalBsCnt &&
                                                it.bsOnlineCnt !== 0
                                        "
                                    />
                                    <img
                                        src="@/assets/img/icon/green.png"
                                        alt=""
                                        v-show="
                                            it.bsOnlineCnt == it.totalBsCnt &&
                                                it.bsOnlineCnt !== 0
                                        "
                                    />
                                </span>
                                <span
                                    style="margin-left:5px;"
                                    v-text="it.barName"
                                    :title="it.barName"
                                ></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- <router-link :to="$PAGE_API.home.children.barManager.children.index.children.groupBar.path+'/'+item.groupId"> -->
                <!-- </router-link> -->
            </li>
        </ul>
    </div>
</template>

<script>
import PAGE_API from "@/apis/pageApi";
import { getAllBarList } from "@/requests/bar";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
    data() {
        return {
            title: PAGE_API.home.children.barManager.title,
            // 全部网吧在线/总数
            allBar: {
                onlineNum: 0,
                totalNum: 0
            },
            groupBarList: [],
            show: false,
            current: -1,
            groupBarId: ""
        };
    },
    mounted() {
        // this.$domFn.addAnimateClass(this.$refs.sider, 'animated zoomInLeft')
    },
    computed: {
        ...mapState({
            groupList: state => state.user.barGroupList,
            recentRemoteNum: state => state.barDetails.recentRemoteNum,
            assistRemoteNum: state => state.barDetails.assistRemoteNum,
            serverOfflineBarNum: state => state.barDetails.serverOfflineBarNum,
            hasRemote: state => state.user.userInfo.hasRemote,
            passportType: state => state.user.userInfo.passportType
        }),
        ...mapGetters({
            allBarNumInfo: "user/allBarNumInfo"
        })
    },
    methods: {
        ...mapActions([
            "user/actionUpdateBarGroupList",
            "barDetails/actionUpdateBarAdminInfo"
        ]),
        // 组件数据初始化
        init() {
            this["barDetails/actionUpdateBarAdminInfo"]();
            this["user/actionUpdateBarGroupList"]();
        },
        async getGroupBarList(val) {
            this.groupBarList = [];
            this.show = !this.show;
            if (this.show) {
                let res = await getAllBarList({
                    groupId: val
                });
                this.groupBarList = res;
            } else {
                this.groupBarList = [];
            }
        },
        toPage(val, ind) {
            this.current = ind;
            this.groupBarId = val;
            this.$router.push({
                path:
                    this.$PAGE_API.home.children.barManager.children.index
                        .children.barDetails.path +
                    "/" +
                    val
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.sider-list-1 {
    width: 200px;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #eaedf1;
    text-align: left;
    text-indent: 20px;
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
}
.sider-title {
    height: 70px;
    line-height: 70px;
    background: #d9dee4;
    font-size: 14px;
    font-weight: 600;
}
.list-1,
.list-2,
.list-3 {
    padding-top: 10px;
    padding-bottom: 10px;
    li {
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        overflow: hidden;
        a {
            display: block;
            color: #333;
            padding-right: 10px;
            transition: all 0.3s;
            &:hover {
                background: #fff;
            }
            &.router-link-active {
                background: #fff;
            }
            > span {
                max-width: 100px;
                display: inline-block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                text-indent: 0px;
            }
            > div {
                float: right;
                max-width: 70px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }
    }
}
.list4 {
    padding-top: 10px;
    padding-bottom: 10px;
    li {
        .title {
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            overflow: hidden;
            display: block;
            color: #333;
            padding-right: 10px;
            transition: all 0.3s;
            &:hover {
                background: #fff;
            }
            > span {
                max-width: 100px;
                display: inline-block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                text-indent: 0px;
            }
            > div {
                float: right;
                max-width: 70px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }
        ul > li {
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            overflow: hidden;
            div {
                overflow: hidden;
                display: block;
                color: #333;
                padding-right: 10px;
                transition: all 0.3s;
                &:hover {
                    background: #fff;
                }
                > span {
                    float: left;
                    margin-left: 30px;
                    max-width: 100px;
                    display: inline-block;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    text-indent: 0px;
                }
            }
        }
    }
}
.list-1 {
    padding-bottom: 5px;
}
.list-2 {
    padding-top: 5px;
    padding-bottom: 5px;
}
.list-3 {
    padding-top: 5px;
    a {
        text-align: left;
    }
}
.line {
    width: 90%;
    margin: auto;
    height: 1px;
    background: #d9dee4;
}
</style>
